"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Legend;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Legend(_ref) {
  var legend = _ref.legend;

  return _react2.default.createElement(
    "div",
    {
      className: "legend"
    },
    legend.map(function (_ref2, key) {
      var id = _ref2.id,
          label = _ref2.label;
      return _react2.default.createElement(
        "div",
        { className: "legend-item legend-" + id, key: key },
        _react2.default.createElement(
          "label",
          null,
          label
        )
      );
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/MinimumEducation/Legend.jsx
// module id = 1244
// module chunks = 0